import { Flex } from "@chakra-ui/react";
import React from "react";
import CustomHeading from "../../../components/text/CustomHeading";
import CustomText from "../../../components/text/CustomText";
import FormInput from "../../../components/form/FormInput";
import CustomPhoneInput from "../../../components/form/PhoneInput";

function CompanyInfo({ payload, setPayload }: any) {
  return (
    <Flex
      flexDir="column"
      gap="22px"
      maxW="666px"
      minH="421px"
      w="100%"
      mx="auto"
    >
      <CustomHeading text="Company Info" family="aeonik-bold" align="center" />
      <CustomText
        text="Enter Company Info of the exhibitor"
        align="center"
        color="yess.neutral600"
      />
      <Flex gap="22px">
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText text="Company Name" size="12px" />
          <FormInput
            ph="Enter Company Name"
            maxW="322px"
            value={payload?.companyName}
            onChange={(e: any) =>
              setPayload({ ...payload, companyName: e.target.value })
            }
          />
        </Flex>
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText text="Job Title" size="12px" />
          <FormInput
            ph="Enter Job Title"
            maxW="322px"
            value={payload?.jobTitle}
            onChange={(e: any) =>
              setPayload({ ...payload, jobTitle: e.target.value })
            }
          />
        </Flex>
      </Flex>
      <Flex flexDir="column" gap="11px" w="100%">
        <CustomText text="Company Email" size="12px" />
        <FormInput
          ph="Enter Email"
          type="email"
          value={payload?.companyEmail}
          onChange={(e: any) =>
            setPayload({ ...payload, companyEmail: e.target.value })
          }
        />
      </Flex>
      <Flex gap="22px">
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText text="Company Location" size="12px" />
          <FormInput
            ph="Enter Company Location"
            maxW="322px"
            value={payload?.companyLocation}
            onChange={(e: any) =>
              setPayload({ ...payload, companyLocation: e.target.value })
            }
            // rightIco={<IconChevDown />}
          />
        </Flex>
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText text="Company Phone Number" size="12px" />
          <CustomPhoneInput
            value={payload?.companyPhone}
            onChange={(e: any) => {
              setPayload({ ...payload, companyPhone: e });
            }}
          />
        </Flex>
      </Flex>
      <Flex gap="22px">
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText text="Address" size="12px" />
          <FormInput
            ph="Enter Address"
            value={payload?.companyAddress}
            onChange={(e: any) =>
              setPayload({ ...payload, companyAddress: e.target.value })
            }
          />
        </Flex>
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText text="City" size="12px" />
          <FormInput
            ph="Enter City Name"
            maxW="322px"
            value={payload?.companyCity}
            onChange={(e: any) =>
              setPayload({ ...payload, companyCity: e.target.value })
            }
            // rightIco={<IconChevDown />}
          />
        </Flex>
      </Flex>
    </Flex>
  );
}

export default CompanyInfo;
